import { secondsToMinutesAndSeconds } from "services/helpers/formatTime";

export const getTimeSliderValue = (
	controlsDisabled: boolean,
	videoFutureTime: number | null,
	videoCurrentTime: number,
	videoDuration: number | null,
): number => {
	if (controlsDisabled || videoDuration === null) {
		return 0;
	}
	return videoFutureTime ?? videoCurrentTime;
};

export const getTimeSliderMax = (
	controlsDisabled: boolean,
	videoDuration: number | null,
): number => (controlsDisabled || !videoDuration ? 1 : videoDuration);

export const getRemainingTime = (
	videoDuration: number | null,
	videoCurrentTime: number,
): string | null => {
	return videoDuration !== null
		? secondsToMinutesAndSeconds(videoDuration - videoCurrentTime, true)
		: null;
};

export const getRemainingTimeInSeconds = (
	videoDuration: number | null,
	videoCurrentTime: number,
): number => {
	return videoDuration ? videoDuration - videoCurrentTime : 0;
};
